import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { GetLocationIdsRequest,Location } from "../../domain";
import { LocationsRepository } from "../../repositories";


@Injectable({ providedIn: 'root' })
export class GetLocationsBySegmentIdUsecase implements UseCase<GetLocationIdsRequest, Location[]> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: GetLocationIdsRequest): Observable<Location[]>{
    return this.locationRepository.GetLocationBySegmentId(params);
  }

}